import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';

import NavLink from '../../Routes/NavLink'

import { modal } from '../../../core/utilities/modal'

export default class Integration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            minimized: false,
            getDataAgain: false,
            reloadData: false,
        }

        this.interval = null;
    }

    componentDidMount() {
        // #  We need to setup our slimScroll on our editing window
		jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '250px',
			alwaysVisible: true
        });
    }

    componentWillUnmount() {
    }

    componentWillUpdate(nextProps, nextState) {

    }

    // #  minimizes SingleTask
    minimizeTask(e) {
        // #  update
        this.setState({
            minimized: true
        });
    }
    /**
    *
    * Maximizes SingleTask
    *
    */
    maximizeTask(e) {
        // #  update
        this.setState({
            minimized: false
        });
    }

    render(){
        const isMinimized = this.props.isMinimized;
        var icon = 'icon-icons8-water';
        if(!isMinimized) {
            return (
                <div class="card">
                    <div class="header">
                        <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                        <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                        <h4 class="title" onClick={this.props.minimizeTask}>Integration</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <div class="scroll-attach">
                            <div class="row">
                                {/* <iframe src="https://passport.appf.io/sign_in" width="100%" height="250px"></iframe> */}
                                {/* <iframe src="https://signin.managebuilding.com/Manager/public/authentication/login" width="100%" height="250px"></iframe> */}
                                {/* <iframe src="https://secure.rentecdirect.com/owners/login.php" width="100%" height="250px"></iframe> */}
                            </div>
                        </div>
                        <div class="footer">
                            <div class="legend">
                            </div>
                            <hr/>
                            <div class="stats">
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="card">
                    <div class="header">
                        <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                        <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.maximizeTask}><i class="pe-7s-angle-up"></i></button>
                        <h4 class="title" onClick={this.props.maximizeTask}>Viewing Sensor <i class={icon}></i></h4>
                        <p class="category"></p>
                    </div>
                </div>
            );
        }
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/Type/Integration.jsx